import React, { useState } from 'react'
import { Accordion, Collapse } from 'react-bootstrap'
import { BiDownArrow, BiUpArrow } from 'react-icons/bi'
export default function Antidotos({ item, index }) {
  const [open, setOpen] = useState(false);
  return (
    <Accordion.Item eventKey={index} key={index}>
      <Accordion.Header>
        {item.name}
      </Accordion.Header>
      <Accordion.Body className='accordionBody'>
        {
          item.description &&
          <div>
            {item.description}
          </div>
        }
        <div className='text-end'>
          {open && <BiUpArrow onClick={() => setOpen(false)} />}
          {
            !open &&
            <div><BiDownArrow onClick={() => setOpen(true)} /> Leer más</div>
          }
        </div>
        <Collapse in={open}>
          <div id="example-collapse-text">
            {

              item.mechanism &&
              <div>
                <b>Mecanismo de Acción: </b>
                {item.mechanism}
              </div>
            }
            {

              item.indications &&
              <div>
                <b>Indicaciones: </b>
                {item.indications}
              </div>
            }
            {

              item.doses &&
              <div>
                <b>Dosis: </b>
                {item.doses}
              </div>
            }
            {

              item.counterindic &&
              <div>
                <b>Contraindicaciones: </b>
                {item.counterindic}
              </div>
            }
            {

              item.effects &&
              <div>
                <b>Efectos Adversos: </b>
                {item.effects}
              </div>
            }
          </div>
        </Collapse>

      </Accordion.Body>
    </Accordion.Item>
  )
}
